var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-page" },
    [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              _vm.searchSubmit($event)
            }
          }
        },
        [
          _c("div", { staticClass: "mobile-search" }, [
            _c("div", { staticClass: "mobile-search-box" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mobileSearch,
                    expression: "mobileSearch"
                  }
                ],
                attrs: { placeholder: "Oklahoma City, OK" },
                domProps: { value: _vm.mobileSearch },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.mobileSearch = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "search-btn", on: { click: _vm.searchAction } },
                [
                  _c("img", {
                    attrs: { src: "/icons/search-white.svg", alt: "Search" }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "toggle-controls" }, [
              _c(
                "button",
                {
                  class: "secondary" + (_vm.mobileViewMap ? " pressed" : ""),
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.mobileViewMap = !_vm.mobileViewMap
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.mobileViewMap ? "CLOSE" : "VIEW MAP") +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class:
                    "secondary" + (_vm.mobileViewFilters ? " pressed" : ""),
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.mobileViewFilters = !_vm.mobileViewFilters
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.mobileViewFilters ? "CLOSE" : "FILTERS") +
                      "\n        "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "search-box",
              class: { expanded: _vm.mobileViewFilters }
            },
            [
              _c("div", { staticClass: "top-tabs" }, [
                _c(
                  "label",
                  {
                    class: { active: _vm.search.tab === "all" },
                    attrs: { for: _vm.id + "_all" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchTab,
                          expression: "searchTab"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_all",
                        type: "radio",
                        name: "own_type",
                        value: "all"
                      },
                      domProps: { checked: _vm._q(_vm.searchTab, "all") },
                      on: {
                        change: function($event) {
                          _vm.searchTab = "all"
                        }
                      }
                    }),
                    _vm._v("All\n          Properties")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "main-options" }, [
                _c("div", [
                  _c("div", { staticClass: "property-types" }, [
                    _c(
                      "div",
                      { staticClass: "check-column" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "check",
                            attrs: { for: _vm.id + "_category-all" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchAllCategories,
                                  expression: "searchAllCategories"
                                }
                              ],
                              attrs: {
                                id: _vm.id + "_category-all",
                                type: "checkbox",
                                name: "category[]",
                                value: "all"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.searchAllCategories)
                                  ? _vm._i(_vm.searchAllCategories, "all") > -1
                                  : _vm.searchAllCategories
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.searchAllCategories,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "all",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.searchAllCategories = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.searchAllCategories = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.searchAllCategories = $$c
                                  }
                                }
                              }
                            }),
                            _c("span", {
                              staticClass: "checkbox",
                              attrs: { tabindex: "0" },
                              on: {
                                keypress: function($event) {
                                  _vm.check($event)
                                }
                              }
                            }),
                            _vm._v(" All Properties\n              ")
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.propertyTypes, function(propertyTy) {
                          return _c("div", [
                            _c(
                              "label",
                              {
                                staticClass: "check",
                                attrs: { for: _vm.id + "_" + propertyTy.text }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.search.propertyType,
                                      expression: "search.propertyType"
                                    }
                                  ],
                                  attrs: {
                                    id: _vm.id + "_" + propertyTy.text,
                                    type: "checkbox",
                                    name: "category[]"
                                  },
                                  domProps: {
                                    value: propertyTy.text,
                                    checked: Array.isArray(
                                      _vm.search.propertyType
                                    )
                                      ? _vm._i(
                                          _vm.search.propertyType,
                                          propertyTy.text
                                        ) > -1
                                      : _vm.search.propertyType
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.search.propertyType,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = propertyTy.text,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.search.propertyType = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.search.propertyType = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.search,
                                          "propertyType",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _c("span", {
                                  staticClass: "checkbox",
                                  attrs: { tabindex: "0" },
                                  on: {
                                    keypress: function($event) {
                                      _vm.check($event)
                                    }
                                  }
                                }),
                                _vm._v(
                                  _vm._s(propertyTy.text) + "\n                "
                                )
                              ]
                            )
                          ])
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-set location" }, [
                  _c("div", { staticClass: "half" }, [
                    _c("label", { attrs: { for: _vm.id + "_city" } }, [
                      _vm._v("CITY")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.city,
                          expression: "search.city"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_city",
                        name: "city",
                        placeholder: "City"
                      },
                      domProps: { value: _vm.search.city },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.search, "city", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "half" }, [
                    _c("label", { attrs: { for: _vm.id + "_state" } }, [
                      _vm._v("STATE")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-arrow" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search.state,
                              expression: "search.state"
                            }
                          ],
                          attrs: { id: _vm.id + "_state", name: "state" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.search,
                                "state",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }),
                          _vm._v(" "),
                          _vm._l(_vm.states, function(state) {
                            return _c(
                              "option",
                              { domProps: { value: state } },
                              [_vm._v(_vm._s(state))]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.search.state === ""
                        ? _c("label", { staticClass: "placeholder" }, [
                            _vm._v("State")
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", { attrs: { for: _vm.id + "_state" } }, [
                      _vm._v("KEYWORD")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.keyword,
                          expression: "search.keyword"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_state",
                        name: "keyword",
                        placeholder: "Keyword"
                      },
                      domProps: { value: _vm.search.keyword },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.search, "keyword", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", { attrs: { for: _vm.id + "_type" } }, [
                      _vm._v("LISTING TYPE")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-arrow" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchTab,
                              expression: "searchTab"
                            }
                          ],
                          attrs: { id: _vm.id + "_type", name: "type" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.searchTab = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("All Properties")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Sales" } }, [
                            _vm._v("For Sale")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Lease" } }, [
                            _vm._v("For Lease")
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-set middle" }, [
                  _c("div", [
                    _c("label", { attrs: { for: _vm.id + "_agent" } }, [
                      _vm._v("AGENT NAME")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-arrow" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search.agentName,
                              expression: "search.agentName"
                            }
                          ],
                          attrs: { id: _vm.id + "_agent", name: "agent" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.search,
                                "agentName",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }),
                          _vm._v(" "),
                          _vm._l(_vm.brokers, function(broker) {
                            return _c(
                              "option",
                              { domProps: { value: broker.search } },
                              [_vm._v(_vm._s(broker.name))]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.search.agentName === ""
                        ? _c("label", { staticClass: "placeholder" }, [
                            _vm._v("Agent Name")
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "half" }, [
                    _c("label", { attrs: { for: _vm.id + "_price-min" } }, [
                      _vm._v("PRICE MIN")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.priceMin,
                          expression: "search.priceMin"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_price-min",
                        name: "price_min",
                        placeholder: "Price Min"
                      },
                      domProps: { value: _vm.search.priceMin },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.search, "priceMin", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "half" }, [
                    _c("label", { attrs: { for: _vm.id + "_price-max" } }, [
                      _vm._v("PRICE MAX")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.priceMax,
                          expression: "search.priceMax"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_price-max",
                        name: "price_max",
                        placeholder: "Price Max"
                      },
                      domProps: { value: _vm.search.priceMax },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.search, "priceMax", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "option-set last" }, [
                  _c("div", { staticClass: "half" }, [
                    _c("label", { attrs: { for: _vm.id + "_sf-min" } }, [
                      _vm._v("SF MIN")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.squareFtMin,
                          expression: "search.squareFtMin"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_sf-min",
                        name: "sf_min",
                        placeholder: "SF Min"
                      },
                      domProps: { value: _vm.search.squareFtMin },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.search,
                            "squareFtMin",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "half" }, [
                    _c("label", { attrs: { for: _vm.id + "_sf-max" } }, [
                      _vm._v("SF MAX")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.squareFtMax,
                          expression: "search.squareFtMax"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_sf-max",
                        name: "sf_max",
                        placeholder: "SF Max"
                      },
                      domProps: { value: _vm.search.squareFtMax },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.search,
                            "squareFtMax",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "half" }, [
                    _c("label", { attrs: { for: _vm.id + "_acre-min" } }, [
                      _vm._v("ACREAGE MIN")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.acreageMin,
                          expression: "search.acreageMin"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_acre-min",
                        name: "acre_min",
                        placeholder: "Acreage Min"
                      },
                      domProps: { value: _vm.search.acreageMin },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.search,
                            "acreageMin",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "half" }, [
                    _c("label", { attrs: { for: _vm.id + "_acre-max" } }, [
                      _vm._v("ACREAGE MAX")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.acreageMax,
                          expression: "search.acreageMax"
                        }
                      ],
                      attrs: {
                        id: _vm.id + "_acre-max",
                        name: "acre_max",
                        placeholder: "Acreage Max"
                      },
                      domProps: { value: _vm.search.acreageMax },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.search,
                            "acreageMax",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex justify-between flex-row-reverse items-end"
                },
                [
                  _vm.search.tab === "Sales"
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "multifamily order-1 flex-grow flex-shrink"
                        },
                        [
                          _vm._v(
                            "For multifamily investment\n          sales, please visit our affiliate "
                          ),
                          _c(
                            "a",
                            { attrs: { href: "http://listings.arausa.com/" } },
                            [_vm._v("ARA Newmark")]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "buttons flex-grow-0 flex-shrink-0 mb-20px mr-35px"
                    },
                    [
                      _vm.activeBroker
                        ? _c(
                            "a",
                            {
                              staticClass: "broker-link",
                              attrs: {
                                href:
                                  "/about-us/brokers/" + _vm.activeBroker.slug
                              }
                            },
                            [_vm._v("View Agent")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "reset",
                          attrs: { type: "reset" },
                          on: { click: _vm.reset }
                        },
                        [_vm._v("Reset Filters")]
                      ),
                      _vm._v(" "),
                      _c("button", { attrs: { type: "submit" } }, [
                        _vm._v("SEARCH")
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "view-bar" }, [
        _c("div", { staticClass: "view-options" }, [
          _vm._v("VIEW:\n      "),
          _c(
            "button",
            {
              class: "view-btn" + (_vm.view === "list" ? " active" : ""),
              on: {
                click: function($event) {
                  _vm.view = "list"
                }
              }
            },
            [_c("span", { staticClass: "icon list" }), _vm._v(" List\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              class: "view-btn" + (_vm.view === "grid" ? " active" : ""),
              on: {
                click: function($event) {
                  _vm.view = "grid"
                }
              }
            },
            [_c("span", { staticClass: "icon grid" }), _vm._v(" Grid\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c("label", { attrs: { for: _vm.id + "_sort" } }, [_vm._v("SORT:")]),
          _vm._v(" "),
          _c("div", { staticClass: "select-arrow" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sortSetter,
                    expression: "sortSetter"
                  }
                ],
                attrs: { id: _vm.id + "_sort" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.sortSetter = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }),
                _vm._v(" "),
                _c("option", { attrs: { value: "priceHighToLow" } }, [
                  _vm._v("Price: Highest to Lowest")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "priceLowToHigh" } }, [
                  _vm._v("Price: Lowest to Highest")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "sqFtHighToLow" } }, [
                  _vm._v("SF: Highest to Lowest")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "sqFtLowToHigh" } }, [
                  _vm._v("SF: Lowest to Highest")
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("google-map", {
        attrs: {
          results: _vm.searchResults,
          loading: _vm.loading,
          expandMap: _vm.mobileViewMap
        },
        on: { markerVisibility: _vm.filterFromMarkers }
      }),
      _vm._v(" "),
      _c(
        "div",
        { class: "results " + _vm.view },
        [
          _vm.searchResults.length === 0 || _vm.loading
            ? _c("h3", [
                _vm._v(_vm._s(_vm.loading ? "Loading…" : "No results found"))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sortResults, function(result) {
            return !_vm.loading && !result.hidden
              ? _c(
                  "div",
                  {
                    ref: "property" + result.propertyId,
                    refInFor: true,
                    staticClass: "result"
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/property/" +
                            result.UrlSlug +
                            "/?tab=" +
                            result.first_listing.ListingTypeName
                        }
                      },
                      [
                        _c("div", {
                          ref: "img" + result.propertyId,
                          refInFor: true,
                          staticClass: "img",
                          style:
                            "background-image:url('" +
                            (result.loadedImage
                              ? result.ImageFileUrl
                              : "/img/default.jpg?v=1") +
                            "')"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "/property/" +
                              result.UrlSlug +
                              "/?tab=" +
                              result.first_listing.ListingTypeName
                          }
                        },
                        [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                result.Name ? result.Name : result.AddressLine1
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", [
                        result.Name && result.Name !== result.AddressLine1
                          ? _c("span", [
                              _vm._v(_vm._s(result.AddressLine1)),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n          " +
                            _vm._s(result.City) +
                            ", " +
                            _vm._s(result.StateAbbreviatedName)
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _vm.sfRate(result) !== null
                          ? _c("span", [_vm._v(_vm._s(_vm.sfRate(result)))])
                          : _vm._e(),
                        _c("br"),
                        _vm._v(
                          "\n          " + _vm._s(result.spaceDescription)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              result.SquareFootageLease
                                ? result.SquareFootageLease +
                                  " SF Available for Lease"
                                : null
                            ) +
                            "\n          "
                        ),
                        result.SquareFootageLease ? _c("br") : _vm._e(),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              result.SquareFootageSale
                                ? result.SquareFootageSale +
                                  " SF Available for Sale"
                                : null
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.view !== "grid"
                        ? _c("p", {
                            domProps: {
                              innerHTML: _vm._s(result.first_listing.Notes)
                            }
                          })
                        : _vm._e()
                    ])
                  ]
                )
              : _vm._e()
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1531e4da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1531e4da","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PropertySearch/Search.vue
// module id = 522
// module chunks = 0